import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatIconModule} from '@angular/material';

import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LockScreenComponent } from './lockscreen/lockscreen.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { VerifierLoginComponent } from './verifier-login/verifier-login.component';
import { VerifierRegisterComponent } from './verifier-register/verifier-register.component';
import { SessionRoutes } from './session.routing';
//import { MymodelComponent } from '../session/mymodel/mymodel.component';
import { ClientAccountModule } from '../client-account/client-account.module';
import { AppMaterialModule } from '../app-material.module';
import { RMLoginComponent } from './rm-login/rm-login.component';
import { PartnerLoginComponent } from './partner-login/partner-login.component';
import { NgxCaptchaModule } from 'ngx-captcha';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    NgxSmartModalModule.forRoot(),
    RouterModule.forChild(SessionRoutes),
    ClientAccountModule,
    AppMaterialModule,
	    NgxCaptchaModule,
    ReactiveFormsModule
  ],
  declarations: [
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    LockScreenComponent,
    //MymodelComponent,
    VerifierLoginComponent,
    VerifierRegisterComponent,
    RMLoginComponent,
    PartnerLoginComponent
  ],
  
})

export class SessionModule {}
